import React from "react";
import { useTaxOrganizerStore } from "../../../../../utils/stores/taxOrganizerStore";
import DocCheckListTaxOrg from "../../../../../components/DocCheckListTaxOrg/DocCheckListTaxOrg";

const UploadDocNav: React.FC = () => {
  const { docsToUpload, responses } = useTaxOrganizerStore();

  return (
    <DocCheckListTaxOrg
      styles={{ padding: "1.5rem", border: "1.5px solid #DADADA" }}
      docsToUpload={docsToUpload}
      responses={responses}
      showTitle
    />
  );
};

export default UploadDocNav;
